import { render, staticRenderFns } from "./PrincipalStatistics.vue?vue&type=template&id=1f3d9c4e&scoped=true"
import script from "./PrincipalStatistics.vue?vue&type=script&lang=js"
export * from "./PrincipalStatistics.vue?vue&type=script&lang=js"
import style0 from "./PrincipalStatistics.vue?vue&type=style&index=0&id=1f3d9c4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d9c4e",
  null
  
)

export default component.exports